import { Component, input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-certificate-error-label',
  template: `
    <i
      role="alert"
      class="icofont icon-certificate-danger default-cursor"
      [ngbTooltip]="
        (errorMessage() ? 'CertificateErrorMessage' : 'CertificateError') | translate: { message: errorMessage() }
      "
      [placement]="placement()"
    ></i>
  `,
  styles: `
    :host {
      display: flex;
      height: 100%;
      width: fit-content;
    }
    .default-cursor {
      cursor: default;
    }
  `,
  imports: [NgbTooltip, TranslatePipe],
})
export class CertificateErrorLabelComponent {
  errorMessage = input<string>();
  public placement = input<string>('auto');
}
